import { Directive, ElementRef } from '@angular/core';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Adds a scan button to the right side inside ion-input elements
 * Does not work on regular input elements
 */
@Directive({
  selector: '[co-input-scanner]'
})
export class CoInputScannerDirective {
  buttonTemplate: string = '<button class="coInputScannerButton">Scan</button';
  constructor(private element: ElementRef, private toast: ToastAlertsProvider) {
    element.nativeElement.insertAdjacentHTML('beforeend', this.buttonTemplate);
    element.nativeElement.querySelector('.coInputScannerButton').addEventListener('click', () => {
      this.scan();
    });
  }
  scan() {
    let lintWindow: any = window;
    if(lintWindow.cordova && lintWindow.cordova.plugins) {
      lintWindow.cordova.plugins.CoScanner.scan({
        message: "Please scan a barcode",
        isISBN: false
      }, (data: any) => {
        if (data.success == true) {
          const input = this.element.nativeElement.querySelector('input');
          input.value = data.result;
          input.dispatchEvent(new Event('input'));
        }
      }, (error: any) => {
        if (error.error != 'USER_CANCELLED') {
          this.toast.showAlert('', error.message);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/input-scanner/input-scanner.ts